module.exports = __webpack_public_path__ + "img/tech_continuous_improvement.4f0a8589.png";